import { useQueryClient } from '@tanstack/react-query'
import { usePutProvidersUserIdLicensesLicenseId, getGetProvidersUserIdQueryKey } from '@/api/generated/doctor/doctor'
import type { License } from '../license-form/transformLicense'

export function useUpdateLicenseVisibility(userId: string) {
  const queryClient = useQueryClient()
  const { mutateAsync: orvalMutateAsync, isPending } = usePutProvidersUserIdLicensesLicenseId()

  async function mutateAsync(license: License, visibility: string) {
    const data = {
      Number: license.Number,
      StateCode: license.StateCode,
      DeaNumber: license.DeaNumber ?? null,
      DeaStateCode: license.DeaStateCode ?? null,
      CslNumber: license.CslNumber ?? null,
      VisitTypes: license.VisitTypes.map((vt) => {
        // Preserve hidden/deeplink visit types — only update user-visible ones
        const isHidden = vt.BaseVisibility === 'none' || vt.BaseVisibility === 'deeplink'
        return {
          VisitTypeId: vt.VisitTypeId,
          VisibilityType: isHidden ? (vt.VisibilityOverride ?? vt.BaseVisibility) : visibility,
        }
      }),
    }
    await orvalMutateAsync({ userId, licenseId: license.LicenseId, data })

    const queryKey = getGetProvidersUserIdQueryKey(userId)
    queryClient.invalidateQueries({ queryKey })
  }

  return { mutateAsync, isPending }
}
